import { useCallback, useState } from 'react';

import { logEvent } from 'features/Analytics/analytics';

export const useToggleSelectedTransactions = (
  inputSelectedTransactions: string[] = [],
) => {
  const [selectedTransactionIds, setSelectedTransactionIds] = useState<
    string[]
  >(inputSelectedTransactions);

  const toggle = useCallback((transactionId: string) => {
    logEvent({ name: 'Select_Dispute_Transaction_Multiple' });
    setSelectedTransactionIds((previousSelectedTransactionIds) => {
      if (previousSelectedTransactionIds.includes(transactionId)) {
        return previousSelectedTransactionIds.filter(
          (id) => id !== transactionId,
        );
      } else {
        return [...previousSelectedTransactionIds, transactionId];
      }
    });
  }, []);

  return {
    selectedTransactionIds,
    setSelectedTransactionIds,
    toggle,
  };
};
